import { useLocation } from 'react-router-dom'
import type { PageTriggerFields } from '@paintscout/util/engagement'
import { pickPageViewItem } from '@paintscout/util/engagement'

/**
 * The page-view item (#25610) to show on the current route, or null: the newest one whose
 * `pathPattern` matches `location.pathname` and that `isOpen` accepts. `isOpen` is the surface's
 * "once" rule (unread, unanswered, not shown in this tab). Startup items are never returned.
 *
 * Kept apart from any one surface so announcements, surveys and the resource center panel
 * (#25353) all decide "does this page fire it" the same way. Must render inside the Router.
 */
export function usePageViewItem<T extends PageTriggerFields & { id: string; publishedAt?: string | null }>(
  items: readonly T[],
  isOpen: (item: T) => boolean
): T | null {
  const { pathname } = useLocation()
  return pickPageViewItem(items, pathname, isOpen)
}
